/* Mushy · Zugaben zur Wahl
   ------------------------------------------------------------------
   Hoechstens data-max Karten gleichzeitig. Wird eine weitere gewaehlt,
   faellt die aelteste Wahl heraus — so bleibt jeder Klick wirksam,
   statt ins Leere zu laufen.

   Die Wahl wandert als Line-Item-Property in das Kaufformular derselben
   Buy-Box. Ohne eigene 0-Euro-Artikel steht sie damit in Warenkorb und
   Bestellung, ohne den Preis zu veraendern.
*/
(function () {
  function setup(group) {
    if (group.dataset.muPicksReady === 'true') return;
    group.dataset.muPicksReady = 'true';

    var max = parseInt(group.dataset.max || '2', 10) || 2;
    var prop = group.dataset.property || '';
    var buttons = Array.prototype.slice.call(group.querySelectorAll('.mu-gift-pick'));
    var order = buttons.filter(function (b) {
      return b.getAttribute('aria-pressed') === 'true';
    });

    // Mehr Vorauswahl im Editor als erlaubt: die ueberzaehligen still abwaehlen.
    while (order.length > max) order.shift().setAttribute('aria-pressed', 'false');

    var box = group.closest('.mu-buybox') || group.parentElement;
    var form = box ? box.querySelector('.mu-buy-form') : null;
    var field = null;

    function sync() {
      if (!form || !prop) return;
      if (!field) {
        field = form.querySelector('[data-mu-picks-input]');
        if (!field) {
          field = document.createElement('input');
          field.type = 'hidden';
          field.setAttribute('data-mu-picks-input', '');
          form.appendChild(field);
        }
      }
      field.name = 'properties[' + prop + ']';
      // Zugaben mit eigenem Artikel stehen als Position im Warenkorb, die
      // gehoeren nicht noch einmal in die Notiz.
      field.value = order
        .filter(function (b) { return !b.dataset.variant; })
        .map(function (b) { return b.dataset.title || ''; })
        .filter(Boolean)
        .join(', ');
      // Leeres Feld gar nicht erst mitschicken.
      field.disabled = field.value === '';
    }

    group.addEventListener('click', function (ev) {
      var btn = ev.target.closest('.mu-gift-pick');
      if (!btn || !group.contains(btn)) return;

      if (btn.getAttribute('aria-pressed') === 'true') {
        btn.setAttribute('aria-pressed', 'false');
        order = order.filter(function (b) { return b !== btn; });
      } else {
        btn.setAttribute('aria-pressed', 'true');
        order.push(btn);
        while (order.length > max) order.shift().setAttribute('aria-pressed', 'false');
      }
      sync();
    });

    sync();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-mu-picks]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme-Editor: Section neu geladen, Karten neu verdrahten.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  // Bundle gewechselt: mu-bundle-switch tauscht das Markup des Heros aus,
  // die neuen Karten haben noch keinen Zuhoerer.
  document.addEventListener('mu:bundle-change', function () { init(); });
})();
